module.exports = __webpack_public_path__ + "static/Abdullah-b9afb9c3d8d13d632a3bcb85de8bc3e2.png";